module.exports = __webpack_public_path__ + "6b81ecc17e6f78ea7a161c9af6d77cd8.svg";